const US_TERRITORY_CODES = ["as", "gu", "mp", "pr", "vi", "um"];

/**
 * Converts URL slugs back to human-readable query strings for geocoding.
 * e.g. "kern-county" → "kern county", "california-city" → "california city"
 */
export function deslugifySegments(segments: string[]): string[] {
  return segments.map((s) => s.replace(/-/g, " "));
}

function parseCountryCode(countryCode: string): string[] {
  if (countryCode.toLowerCase() === "us") {
    return ["us", ...US_TERRITORY_CODES];
  }

  return [countryCode];
}

export function parseCountryCodes(countryCodes: string[]): string {
  const result = new Set<string>();

  for (const code of countryCodes) {
    const parsedCodes = parseCountryCode(code);

    for (const parsedCode of parsedCodes) {
      result.add(parsedCode);
    }
  }

  return Array.from(result).join(",");
}
